import { Task } from '../../api/tasks';

export const DEFAULT_TASK_TYPE = 'user';

export const getNextScheduledTime = (
  schedule: Task['schedule'],
): Date | null => {
  if (!schedule) {
    return null;
  }

  const now = new Date();

  // Handle one-time schedule
  if ('runAt' in schedule) {
    const runAt = new Date(schedule.runAt);
    return runAt > now ? runAt : null;
  }

  // Validate time format (HH:mm)
  if (!schedule.time || !/^\d{1,2}:\d{2}$/.test(schedule.time)) {
    throw new Error('Invalid time format. Expected HH:mm');
  }

  const [hours, minutes] = schedule.time.split(':').map(Number);

  const scheduledDate = new Date();
  scheduledDate.setHours(hours, minutes, 0, 0);

  switch (schedule.frequency) {
    case 'daily':
      if (scheduledDate <= now) {
        scheduledDate.setDate(scheduledDate.getDate() + 1);
      }
      break;

    case 'weekly':
      if (
        typeof schedule.dayOfWeek === 'number' &&
        schedule.dayOfWeek >= 0 &&
        schedule.dayOfWeek <= 6
      ) {
        while (
          scheduledDate.getDay() !== schedule.dayOfWeek ||
          (scheduledDate.getDay() === schedule.dayOfWeek &&
            scheduledDate <= now)
        ) {
          scheduledDate.setDate(scheduledDate.getDate() + 1);
        }
      } else {
        throw new Error('Invalid or missing dayOfWeek for weekly schedule');
      }
      break;

    case 'monthly':
      if (typeof schedule.dayOfMonth === 'number' && schedule.dayOfMonth > 0) {
        const daysInMonth = new Date(
          scheduledDate.getFullYear(),
          scheduledDate.getMonth() + 1,
          0,
        ).getDate();

        // Clamp the day to the max day of the month
        const validDay = Math.min(schedule.dayOfMonth, daysInMonth);
        scheduledDate.setDate(validDay);

        if (scheduledDate <= now) {
          scheduledDate.setMonth(scheduledDate.getMonth() + 1);

          // Re-validate the day after month increment
          const nextMonthDays = new Date(
            scheduledDate.getFullYear(),
            scheduledDate.getMonth() + 1,
            0,
          ).getDate();
          scheduledDate.setDate(Math.min(schedule.dayOfMonth, nextMonthDays));
        }
      }
      break;

    default:
      throw new Error('Invalid schedule frequency');
  }

  return scheduledDate;
};
